// Copyright (C) Microsoft Corporation. All rights reserved.

import { Init } from './RecoveryImageDownload';
(<any>window).RecoveryImagesDownload = Init;
